import { LogoLoading } from '@/shared/modules/logo-loading/LogoLoading';

export const Loading = () => (
  <div
    style={{
      height: '80vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}
  >
    <LogoLoading />
  </div>
);
